<div [ngClass]="{'opacity-0 pointer-events-none' : !modalService.open, 'opacity-100 pointer-events-auto' : modalService.open}" class="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  
  <!--
    Background backdrop, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0"
      To: "opacity-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100"
      To: "opacity-0"
  -->
  <div [ngClass]="{'opacity-0' : !modalService.open, 'opacity-100' : modalService.open}" class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity ease-in-out duration-300" aria-hidden="true"></div>

  <div class="fixed inset-0 z-50 w-full overflow-y-auto">
    <div class="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
      <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
      <div [ngClass]="{'opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95' : !modalService.open, 'opacity-100 translate-y-0 sm:scale-100' : modalService.open}" class="ease-in-out duration-300 relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all w-full sm:my-8 sm:w-full sm:max-w-4xl sm:p-6">

        <div class="">
          <div class="flex items-start justify-between">
            <h2  class="text-base font-semibold leading-6 text-gray-900" id="slide-over-title">
              {{ modalService.title }}
            </h2>
            <div class="ml-3 flex h-7 items-center">
              <button type="button" (click)="closeClicked()" class="relative rounded-md text-accent hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-accent-light focus:ring-offset-2">
                <span class="absolute -inset-2.5"></span>
                <span class="sr-only">Close panel</span>
                <svg class="h-6 w-6 " fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        
        <ng-container *ngIf="modalService.mode === 'new-horse' || modalService.mode === 'edit-horse'">
          <ubc-new-horse-form *ngIf="modalService.customer" [customer]="modalService.customer" (horseCreated)="horseCreated()"></ubc-new-horse-form>
        </ng-container>
        <ng-container *ngIf="modalService.mode === 'new-address' || modalService.mode === 'edit-address'">
          <ubc-new-address-form></ubc-new-address-form>
        </ng-container>
        
        
      </div>
    </div>
  </div>
</div>
